module.exports = __webpack_public_path__ + "media/images/placeholders/500-cbef224a8cbf113e77d1774c4728afcb.svg";